import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Switch, Route, Redirect } from 'react-router-dom';
import components from 'components';
import PageHeader2 from 'components/common/PageHeader2';
import { url } from 'services/router-service';

const AdminLayout: React.FC = () => {
  const history = useHistory();  
  const location = useLocation();

  const activeTab = determineActiveTab(location.pathname);
  const tabs = ["Contacts", "Companies", "Company File Types", "Document Types", "CCPA Scrub"]; 
  const handleNavigation = (tabName: string) => {
    let route = '';
    switch (tabName) {
      case 'Contacts': route = url.contacts ; break;
      case 'Companies': route = url.companies; break;
      case 'Company File Types': route = url.companyFileTypes; break;
      case 'Document Types': route = url.documentTypes; break;
      case 'CCPA Scrub': route = url.ccpaScrub; break; 
      default: route = url.contacts;
    }
    history.push(route); 
  };

  return (
    <>
      <PageHeader2
        activeTab={activeTab}
        onTabSelect={handleNavigation}
        tabs={tabs}
      />
      <main> 
        <Switch>
          <Route exact path={url.admin}> 
            <Redirect to={url.contacts} />
          </Route>

          <Route exact path={url.contacts} component={components.Contacts} />
          <Route path={url.companies} component={components.Companies} />
          <Route path={url.companyFileTypes} component={components.CompanyFileTypes} />
          <Route path={url.documentTypes} component={components.DocumentTypes} />
          <Route path={url.ccpaScrub} component={components.CcpaScrub} />
        </Switch>
      </main>      
    </>
  );
}

function determineActiveTab(pathname: string) {
  if (pathname.startsWith(url.companies)) return 'Companies';
  if (pathname.startsWith(url.companyFileTypes)) return 'Company File Types';
  if (pathname.startsWith(url.documentTypes)) return 'Document Types';
  if (pathname.startsWith(url.ccpaScrub)) return 'CCPA Scrub';  
  if (pathname.startsWith(url.contacts)) return 'Contacts';
  return 'Contacts';
}

export default AdminLayout;